import api from '../../../../../../utils/api'
import { useState, useEffect } from "react"
import { FiInbox } from 'react-icons/fi'
import { MdAddPhotoAlternate } from 'react-icons/md'

/* form */
import NewClientImg from "../../../../../ClientImg/NewClientImg"
import Button from "../../../../../../shared/components/Button/Button"

//list
import ListClientImgRow from "../../../../../ClientImg/ListRow/ListClientImgRow"
//Modal
import Modal from '../../../../../../shared/modal/Modal'

function EditImgPrint({ clientId, title, handleOnSelect, btCancelAction }) {
    const [clientImgs, setClientImgs] = useState([])
    const [token] = useState(localStorage.getItem('token') || '')
    const [load, setLoad] = useState(false)

    const [modalNewClientImg, setModalNewClientImg] = useState(false)
    const newClientImg = (status) => {
        if (status === 'success') {
            setModalNewClientImg(false)
        }
    }

    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    const getAll = () => {
        api.get(`clientImg/getallimgbyclient/${clientId}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {
            if (response.data) {
                setClientImgs(response.data.clientImgs)
                setLoad(true)
            }
        })
    }

    const listUpdate = () => {
        getAll()
    }

    const handleSelect = (item) => {
        handleOnSelect(item)
        btCancelAction && btCancelAction()
    }

    if (!load) {
        return <div className="pg-loading">Carregando imagens...</div>
    }

    return (
        <section className="pg-page">
            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">{title || 'Imagens de Referência'}</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            <Button variant="new" icon={MdAddPhotoAlternate} onClick={() => setModalNewClientImg(true)}>Nova Imagem</Button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {clientImgs.length > 0 ? (
                    <ListClientImgRow dataArray={clientImgs} handleOnSelect={handleSelect} />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhuma imagem cadastrada</p>
                        <p className="pg-empty-subtitle">Cadastre a primeira imagem de referência deste cliente.</p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNewClientImg}
                changeStatus={setModalNewClientImg}
                w={60}
                content={
                    <NewClientImg clientId={clientId} handleSubmit={newClientImg} handleOnSuccess={listUpdate} btCancelAction={() => setModalNewClientImg(false)} />
                }
            />
        </section>
    )
}

export default EditImgPrint
